var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "myCourse bjStyle" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "我的课程", name: "my-course" } },
              [_c("CourseList")],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "教材版本", name: "textbook-version" } },
              [_c("TextbookVersions")],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }